import { ICollaborator } from '@company/components/Collaborator/ICollaborator';

export const isFeedVisible = (labels: string[]) => {
  const availableStatuses = ['seeking_funding', 'funded', 'pre-listed', 'unsuccessful_pitch'];
  let isFeedVisible = false;
  if (labels.some(v => availableStatuses.indexOf(v) >= 0)) {
    isFeedVisible = true;
  }
  return isFeedVisible;
};

export const userIsCollaborator = (profileId: number | null, collaborators: ICollaborator[]): boolean => {
  const isCollaborator = collaborators.find((collaborator: ICollaborator) => {
    return collaborator.profile_id === profileId;
  });

  return isCollaborator !== undefined;
};
